export default __webpack_public_path__ + "static/media/team-photo-2021.b5a0de7c.png";